import $ from 'jquery';
import hub from '../utility/events-hub';
import isInViewport from '../utility/isInViewport';

const addLoadingAnimation = (evt) => {
    const $form = $(evt.currentTarget);
    if (!$form.valid()) return;

    const $clickedButton = $(document.activeElement);
    const $remainingButtons = $form.find('[type=submit]').not($clickedButton);

    $remainingButtons.prop('disabled', true);
    $clickedButton.addClass('loading');
};

const inputRestriction = function (e) {
    const pattern = $(e.target).attr('pattern');

    if (!pattern) {
        return;
    }

    const regex = new RegExp(pattern);
    const str = String.fromCharCode(!e.charCode ? e.which : e.charCode);

    if (!regex.test(str)) {
        e.preventDefault();
    }
};

const getAttrOrDefault = ($control, attribute, defaultValue) => {

    const str = $control.attr(attribute);
    let result = defaultValue;
    if (str.length) {
        const parsed = parseInt(str, 10);
        if (!isNaN(parsed)) {
            result = parsed;
        }
    }
    return result;
};

const ensureMinMaxControl = function($control) {
    const minQuantity = getAttrOrDefault($control, 'min', 0);
    const maxQuantity = getAttrOrDefault($control, 'max', 0);

    const amountBefore = +$control.val();
    let amount = +$control.val();

    amount = amount < minQuantity ? minQuantity : amount;
    amount = amount > maxQuantity ? maxQuantity : amount;

    if (amountBefore !== amount) {
        $control.val(amount);
        hub.publish(hub.event.quantityUpdated, { $control });
    }
};

const ensureMinMax = function (e) {
    const $control = $(e.target);
    ensureMinMaxControl($control);
};

const ensureDependentMinMax = function (e) {
    const $control = $(e.target);
    const $dependent = $control.parents('.js-product-basket-wrap').find($control.data('dependent'));
    ensureMinMaxControl($dependent);
};

const inputCounter = function(e){
    const $control = $(e.target);
    $control.parents('.form-row-textarea-counter').attr('data-currentlength', $control.val().length);
};

const setGlobalValidatorConfig = function() {
    const $forms = $('form');

    $forms.each(function() {
        const validator = $(this).validate();
        validator.settings.ignore = ':hidden:not([data-validate-hidden-field="true"])';

        $(this).bind('invalid-form.validate', function (e) {
            // Hidden elements cannot be scrolledIntoView by jQuery Validation as they are not in the RenderDOM.
            // Instead we scroll to the related validation error
            const $form = $(e.target);
            const $firstErrorMessage = $form.find('.field-validation-error[data-valmsg-for]').first();

            if (!$firstErrorMessage.length) {
                return;
            }

            const relatedInputTargetName = $firstErrorMessage.data('valmsg-for');

            const $relatedInputField = $(`[name="${relatedInputTargetName}"]`);
            const isRelatedInputFieldHiddenAndShouldValidate = $relatedInputField.data('validate-hidden-field') === true;

            if (!isRelatedInputFieldHiddenAndShouldValidate || isInViewport($firstErrorMessage[0])) {
                return;
            }

            const y = $firstErrorMessage[0].getBoundingClientRect().top + window.pageYOffset + -50;

            window.scrollTo({top: y});
        });

    });
};

const init = (opts) => {
    const defaults = {
        selectors: {
            form: '.js-form-submit-loading'
        }
    };

    const options = $.extend(true, defaults, opts);
    $(document).on('submit', options.selectors.form, addLoadingAnimation);

    $('body').on('input', '[data-count-restriction]', inputCounter);
    $('body').on('keypress', '[data-input-restriction]', inputRestriction);
    $('body').on('change', '[data-min-max-restriction]', ensureMinMax);
    $('body').on('click', '[data-dependent-min-max-restriction]', ensureDependentMinMax);

    setGlobalValidatorConfig();
};

export default {
    init
};
